module.exports = __webpack_public_path__ + "img/141.10.2ce2f99b.png";